// Onde está a API. Em produção a loja e a API estão no mesmo endereço ("same-origin"); em testes pode ser outro servidor.
// Sem valor, a loja funciona só com o catálogo incluído no site e o painel fica indisponível.
// Em produção, sem indicação em contrário, a API está no mesmo endereço da loja. REACT_APP_BACKEND_URL="" desliga a API.
const raw = process.env.REACT_APP_BACKEND_URL ?? (process.env.NODE_ENV === "production" ? "same-origin" : "");
export const SAME_ORIGIN = raw === "same-origin";
export const BACKEND_URL = SAME_ORIGIN ? "" : raw.replace(/\/$/, "");
export const HAS_BACKEND = SAME_ORIGIN || !!raw;
export const API_URL = HAS_BACKEND ? `${BACKEND_URL}/api` : null;
